// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  firebase: {

    apiKey: "AIzaSyDfBJtlWmV-FnNdNyB7vQbHWLbJWfJWU_Q",
    authDomain: "bifrost-admin-ab907.firebaseapp.com",
    databaseURL: "https://bifrost-admin-ab907.firebaseio.com",
    projectId: "bifrost-admin-ab907",
    storageBucket: "bifrost-admin-ab907.appspot.com",
    messagingSenderId: "986241455772",
    appId: "1:986241455772:web:eb4929b3caf1d243223f59"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
